import React from "react";
import "../assets/css/About.css";

import aboutImg from "../assets/images/about/att.jpg";

const AboutContent = () => {
  return (
    <section className="about-section py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <h2 className="about-title">
              <span>About us</span>
            </h2>

            <p className="about-title-color">
              We are decisive, hard-working and thesis-driven
              investors. We seek out extraordinary business leaders
              who operate the same way.
            </p>

            <ul className="about-list about-title-color">
              <li>
                We are a technology and software-focused investment
                firm.
              </li>

              <li>
                We have a strong, team-based culture.
              </li>

              <li>
                We fuel strong relationships based on support.
              </li>

              <li>
                We hone our market perspective with sector-specific
                research.
              </li>
            </ul>
          </div>

          {/* Right */}
          <div className="col-lg-6">
            <img
              src={aboutImg}
              alt="about"
              className="img-fluid about-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutContent;